__turbopack_context__.v({
  "error": "CreateWalletPassword-module__UoMlya__error",
  "form": "CreateWalletPassword-module__UoMlya__form",
  "input": "CreateWalletPassword-module__UoMlya__input",
});
